/* eslint no-underscore-dangle: 0 */
/* eslint import/no-extraneous-dependencies: 0 */
/* eslint-disable object-shorthand */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { toPng } from 'html-to-image';
import { setErrorNotification } from '../../../../redux/slices/NotificationSlice';
import ModalBox from '../../../../shared/component/ModalBox';
import TemplateContentUpload from '../TemplateContentUpload';
import HtmlHeader from '../HtmlHeader';
import utils from '../templateFunctions';
import FileFormat from '../FileFormat';
import { createOrUpdateTemplate } from '../../../../redux/slices/TemplateSlice';
import PopupBox from '../ContentUploadConfirmation';

function HtmlTemplateThirtyFour({ templateData }) {
  const [data, setData] = useState([]);
  const [notification, setNotification] = useState(false);
  const [openContentUploadConfirmation, setOpenContentUploadConfirmation] = useState(false);
  const [base64, setBase64] = useState('');
  const [htmlContent, setHtmlContent] = useState('');
  const [disable, setDisable] = useState(true);
  const [modalView, setModalView] = useState({ content: '', title: '' });
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const htmlRef = useRef(null);

  const cssStyles = `
    body {
      margin: 0;
      padding: 0;
    }
    .welcome-card {
      position: relative;
      font-family: "Montserrat", sans-serif;
      box-sizing: border-box;
      overflow: hidden;
    }
    .welcome-card__background-transparent-top {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 50%;
      object-fit: cover;
    }
    .welcome-card__background-transparent-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 90px;
      object-fit: cover;
    }
    .welcome-card__content {
      max-width: max-content;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .welcome-card .main-container {
      padding: 30px;
      height: 93.6vh;
      display: flex;
      align-items: center;
      flex-direction: column;
      padding-block-start: 50px;
    }
    .welcome-card .left-top-image--top {
      position: absolute;
      width: 61px;
      height: 100px;
      top: 60px;
    }
    .welcome-card .left-top-image--bottom {
      position: absolute;
      width: 61px;
      height: 31px;
      top: 80px;
      inset-inline-end: 0;
    }
    .welcome-card .detils-welcome {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 20px;
    }
    .welcome-card .detils-welcome__title {
      text-align: end;
      color: #fff;
      margin: 0;
    }
    .welcome-card .detils-welcome__title .highlight-first {
      font-size: 52px;
      font-weight: 800;
      text-shadow: -6px 11px rgba(0, 0, 0, 0.3490196078);
    }
    .welcome-card .detils-welcome__title .highlight-middle {
      font-size: 40px;
      font-weight: 400;
      display: block;
      font-family: "Meie Script", cursive;
      color: #FBE106;
      padding-block-start: 10px;
      position: relative;
      inset-inline-start: 30px;
    }
    .welcome-card .detils-welcome__image {
      border: 10px solid #162A70;
      border-radius: 50%;
      width: 500px;
      height: 500px;
    }
    .welcome-card .detils-welcome__image--photo {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }
    .welcome-card .detils-welcome__image--arrow1 {
      position: absolute;
      width: 120px;
      top: 150px;
      inset-inline-start: -15px;
      transform: rotate(9deg);
    }
    .welcome-card .detils-welcome__image--arrow2 {
      position: absolute;
      width: 120px;
      top: -170px;
      inset-inline-end: 18px;
      transform: rotate(180deg);
    }
    .welcome-card .detils-welcome__name {
      font-size: 40px;
      font-weight: 600;
      color: #fff;
      margin: 0px;
    }
    .welcome-card .detils-welcome__role {
      font-size: 20px;
      font-weight: 500;
      color: #fff;
      margin: 0px;
    }
    .welcome-card .right-bottom-image--bottom {
      position: absolute;
      bottom: 0;
      width: 80px;
      height: 114px;
      inset-inline-end: 10px;
    }
  `;

  const convertImage = async (url) => {
    await utils.convertSignedUrl(url)
      .then((response) => {
        setDisable(false);
        dispatch(createOrUpdateTemplate(response));
      })
      .catch((error) => {
        setDisable(false);
        dispatch(setErrorNotification(error?.response?.data));
      });
  };

  const convertBase64 = async () => {
    toPng(htmlRef?.current, { cacheBust: true })
      .then((dataUrl) => {
        setBase64(dataUrl);
        convertImage(dataUrl);
      })
      .catch((error) => {
        dispatch(setErrorNotification(error?.response?.data));
      });
  };

  const convertHtml = () => {
    if (htmlRef.current) {
      const content = htmlRef.current.outerHTML;
      const fullHtml = `
        <html>
          <head>
              <link rel="preconnect" href="https://fonts.googleapis.com" />
              <link rel="preconnect" href="https://fonts.gstatic.com" />
              <link 
              href="https://fonts.googleapis.com/css2?family=Great+Vibes&family=Urbanist:wght@100..900&display=swap" 
              rel="stylesheet" />
              <style>${cssStyles}</style>
          </head>
          <body>${content}</body>
        </html>
      `;
      setHtmlContent(fullHtml); // Set the HTML content as a string
    }
  };

  useEffect(() => {
    utils?.initializer(templateData).then((res) => (setData(res)));
    utils?.reload();
  }, [templateData]);

  /* useEffect runs convertBase64 after data is updated */
  useEffect(() => {
    if (data) {
      /* used settimeout the page was fully rendered and then called the api so wait for the response */
      setTimeout(() => {
        convertBase64();
      }, 1000);
      convertHtml();
    }
  }, [data]);

  const handleFileType = (fileType) => {
    setModalView({
      title: 'content',
      content: <TemplateContentUpload
        base64={base64}
        setNotification={setNotification}
        fileType={fileType}
        htmlContent={htmlContent}
      />,
    });
  };

  const onClickContentUpload = () => {
    setNotification(true);
    setModalView({
      title: t('fileFormat'),
      content: <FileFormat
        setNotification={setNotification}
        handleFileType={handleFileType}
        setOpenContentUploadConfirmation={setOpenContentUploadConfirmation}
        data={data}
      />,
    });
  };

  const contentDetails = data?.[0]?.template_contents?.items?.[0]?.details;
  const backgroundColor = data?.[0]?.styles?.background;
  const backgroundImage = Array.isArray(data?.[0]?.template_backgroundImage_url)
    ? data?.[0]?.template_backgroundImage_url
    : [];

  return (
    <div>
      <HtmlHeader
        htmlData={data}
        disable={disable}
        click={onClickContentUpload}
      />

      <ModalBox
        status={notification}
        closeModal={setNotification}
        modalView={modalView}
      />

      <ModalBox
        status={openContentUploadConfirmation}
        closeModal={setOpenContentUploadConfirmation}
        modalView={{
          title: 'Confirmation',
          content: <PopupBox
            setOpenContentUploadConfirmation={setOpenContentUploadConfirmation}
            setNotification={setNotification}
          />,
        }}
      />

      <div className="header-height" />

      <div ref={htmlRef} className="welcome-card">
        <img className="welcome-card__background-transparent-top" src={backgroundImage[0]} alt="Left Top" />
        <img className="welcome-card__background-transparent-bottom" src={backgroundImage[5]} alt="Left Top" />
        <div className="left-top-image">
          <motion.img
            className="left-top-image--top"
            src={backgroundImage?.[2]}
            alt="Left Top"
            initial={{ opacity: 0, scale: 0.3 }}
            animate={{
              opacity: 1,
              scale: [0.3, 1.1, 1],
              y: [30, -10, 0],
            }}
            transition={{ duration: 0.5, ease: 'easeOut', delay: 0.2 }}
          />

          <motion.img
            className="left-top-image--bottom"
            src={backgroundImage?.[1]}
            alt="Right Bottom"
            initial={{ opacity: 0, scale: 0.3 }}
            animate={{
              opacity: 1,
              scale: [0.3, 1.1, 1],
              y: [30, -10, 0],
            }}
            transition={{ duration: 0.5, ease: 'easeOut', delay: 0.2 }}
          />
        </div>

        <div style={{ backgroundColor: `${backgroundColor}` }} className="main-container">
          <motion.p
            className="welcome-card__textX1"
            initial={{ opacity: 0, scale: 0.3 }}
            animate={{
              opacity: 1,
              scale: [0.3, 1.1, 1],
              y: [30, -10, 0],
            }}
            transition={{ duration: 0.5, ease: 'easeOut', delay: 0.2 }}
          >
            XXXX
          </motion.p>

          <div className="welcome-card__content">

            <div className="detils-welcome">
              <h2 className="detils-welcome__title">
                <motion.span
                  className="highlight-first"
                  initial={{ opacity: 0, scale: 0.3 }}
                  animate={{
                    opacity: 1,
                    scale: [0.3, 1.1, 1],
                    y: [30, -10, 0],
                  }}
                  transition={{ duration: 0.4, ease: 'easeOut' }}
                >
                  {
                    contentDetails?.[0]?.item_name
                      ? contentDetails?.[0]?.item_name?.split(' ')[0].toUpperCase()
                      : ''
                  }{' '}
                </motion.span>

                <motion.span
                  className="highlight-middle"
                  initial={{ opacity: 0, scale: 0.3 }}
                  animate={{
                    opacity: 1,
                    scale: [0.3, 1.1, 1],
                    y: [30, -10, 0],
                  }}
                  transition={{ duration: 0.5, ease: 'easeOut', delay: 0.2 }}
                >
                  {contentDetails?.[0]?.item_name
                    ?.split(' ')
                    .slice(1)
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())}
                </motion.span>
              </h2>

              <div className="detils-welcome__image">
                <motion.img
                  className="detils-welcome__image--arrow1"
                  src={backgroundImage?.[4]}
                  alt="Welcome Photo"
                  initial={{ opacity: 0, scale: 0.3 }}
                  animate={{
                    opacity: 1,
                    scale: [0.3, 1.1, 1],
                    y: [50, -20, 0],
                  }}
                  transition={{ duration: 0.5, ease: 'easeOut', delay: 0.2 }}
                />
                <motion.img
                  className="detils-welcome__image--photo"
                  src={contentDetails?.[0]?.image}
                  alt="Welcome Photo"
                  initial={{ opacity: 0, scale: 0.3 }}
                  animate={{
                    opacity: 1,
                    scale: [0.3, 1.1, 1],
                    y: [50, -20, 0],
                  }}
                  transition={{ duration: 0.4, ease: 'easeOut' }}
                />
                <motion.img
                  className="detils-welcome__image--arrow2"
                  src={backgroundImage?.[4]}
                  alt="Welcome Photo"
                  initial={{ opacity: 0, scale: 0.3, rotate: 175 }}
                  animate={{
                    opacity: 1,
                    scale: [0.3, 1.1, 1],
                    y: [50, -20, 0],
                    rotate: 175,
                  }}
                  transition={{ duration: 0.5, ease: 'easeOut', delay: 0.2 }}
                />
              </div>

              <motion.h4
                className="detils-welcome__name"
                initial={{ opacity: 0, scale: 0.3 }}
                animate={{
                  opacity: 1,
                  scale: [0.3, 1.1, 1],
                  y: [30, -10, 0],
                }}
                transition={{ duration: 0.5, ease: 'easeOut', delay: 0.2 }}
              >
                {contentDetails?.[0]?.name ? contentDetails?.[0]?.name?.toUpperCase() : ''}
              </motion.h4>

              <motion.p
                className="detils-welcome__role"
                initial={{ opacity: 0, scale: 0.3 }}
                animate={{
                  opacity: 1,
                  scale: [0.3, 1.1, 1],
                  y: [30, -10, 0],
                }}
                transition={{ duration: 0.5, ease: 'easeOut', delay: 0.4 }}
              >
                {contentDetails?.[0]?.description ? contentDetails?.[0]?.description?.toUpperCase() : ''}
              </motion.p>
            </div>
          </div>

          <motion.p
            className="welcome-card__textX1 welcome-card__textX2"
            initial={{ opacity: 0, scale: 0.3 }}
            animate={{
              opacity: 1,
              scale: [0.3, 1.1, 1],
              y: [30, -10, 0],
            }}
            transition={{ duration: 0.5, ease: 'easeOut', delay: 0.6 }}
          >
            XXXX
          </motion.p>
        </div>

        <div className="right-bottom-image">
          <motion.img
            className="right-bottom-image--bottom"
            src={backgroundImage?.[3]}
            alt="Right Bottom"
            initial={{ opacity: 0, scale: 0.3 }}
            animate={{
              opacity: 1,
              scale: [0.3, 1.1, 1],
              y: [30, -10, 0],
            }}
            transition={{ duration: 0.5, ease: 'easeOut', delay: 0.2 }}
          />
        </div>
      </div>
    </div>
  );
}

HtmlTemplateThirtyFour.propTypes = {
  templateData:
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      template_title: PropTypes.string.isRequired,
    }).isRequired,
  // Ensure templateData is an array of objects with specific shape
};

export default HtmlTemplateThirtyFour;
